module.exports = __webpack_public_path__ + "img/read-email-letter.eaad9394.svg";